import React from 'react';
import { translate } from 'react-i18next';
import SideBarNavigationLink from '../layout/SideBarNavigationLink';

import { Icon } from '../icons';

const NewProfileLink = ({ t, organisationId }) => {
  return (
    <ul className="profile-list">
      <SideBarNavigationLink to={`/organisations/${organisationId}/profiles/new`} >
        <Icon type={'plus'} className="profile-icon"/>
        <div className="profile-name">{t('CREATE_NEW_PROFILE')}</div>
      </SideBarNavigationLink>
    </ul>
  )
}

export default translate('profile')(NewProfileLink);



// WEBPACK FOOTER //
// ./src/components/layout/NewProfile.js